import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { DashboardLayout } from "./components/layout/DashboardLayout";

// Pages
import Login from "./pages/Login";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminRecharge from "./pages/admin/AdminRecharge";
import SubadminsManagement from "./pages/admin/SubadminsManagement";
import UsersManagement from "./pages/admin/UsersManagement";
import ServicesManagement from "./pages/admin/ServicesManagement";
import TransactionsHistory from "./pages/admin/TransactionsHistory";
import BalanceMovements from "./pages/admin/BalanceMovements";
import UserDashboard from "./pages/user/UserDashboard";
import Recharge from "./pages/user/Recharge";
import UserHistory from "./pages/user/UserHistory";
import UserBalance from "./pages/user/UserBalance";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />

            {/* Admin routes */}
            <Route element={<DashboardLayout requireAdmin={true} />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/recharge" element={<AdminRecharge />} />
              <Route path="/admin/subadmins" element={<SubadminsManagement />} />
              <Route path="/admin/users" element={<UsersManagement />} />
              <Route path="/admin/services" element={<ServicesManagement />} />
              <Route path="/admin/transactions" element={<TransactionsHistory />} />
              <Route path="/admin/balance" element={<BalanceMovements />} />
            </Route>

            {/* User routes */}
            <Route element={<DashboardLayout requireAdmin={false} />}>
              <Route path="/dashboard" element={<UserDashboard />} />
              <Route path="/dashboard/recharge" element={<Recharge />} />
              <Route path="/dashboard/history" element={<UserHistory />} />
              <Route path="/dashboard/balance" element={<UserBalance />} />
            </Route>

            {/* Redirect */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
